import { Routes } from '@angular/router';

//Route for content layout with sidebar, navbar and footer.

export const Full_ROUTES: Routes = [
    {
        path: 'dashboard',
        loadChildren: () => import('../../application/dashboard/dashboard.module').then(m => m.DashboardModule)
    },
    {
        path: 'products',
        loadChildren: () => import('../../application/products/products.module').then(m => m.ProductsModule)

    },
    {
        path: 'payment',
        loadChildren: () => import('../../application/products/products.module').then(m => m.ProductsModule)

    },
    // {
    //     path: 'application',
    //     loadChildren: () => import('../../application/application.module').then(m => m.ApplicationModule)

    // },
    {
        path: 'account',
        loadChildren: () => import('../../application/account/account.module').then(m => m.AccountModule)
    }
    // {
    //     path: 'widgets',
    //     loadChildren: () => import('../../application/others/widgets/widgets.module').then(m => m.WidgetsModule)

    // },
    // {
    //     path: 'ecommerce',
    //     loadChildren: () => import('../../application/others/ecommerce/ecommerce.module').then(m => m.EcommerceModule)

    // },
    // {
    //     path: 'components',
    //     loadChildren: () => import('../components/components.module').then(m => m.ComponentsModule)
    // },
    // {
    //     path: 'content',
    //     loadChildren: () => import('../../application/others/content/content.module').then(m => m.ContentModule)
    // },
    // {
    //     path: 'icons',
    //     loadChildren: () => import('../../application/others/icons/icons.module').then(m => m.IconsModule)
    // },
    // {
    //     path: 'form',
    //     loadChildren: () => import('../../application/others/form/form.module').then(m => m.FormModule)
    // },
    // {
    //     path: 'table',
    //     loadChildren: () => import('../../application/others/table/table.module').then(m => m.TableModule)

    // },
    // {
    //     path: 'faq',
    //     loadChildren: () => import('../../application/others/faq/faq.module').then(m => m.FaqModule)
    // },
    // {
    //     path: 'pricing',
    //     loadChildren: () => import('../../application/others/pricing/pricing.module').then(m => m.PricingModule)
    // },
    // {
    //     path: 'earnings',
    //     loadChildren: () => import('../../application/others/earnings/earnings.module').then(m => m.EarningsModule)
    // },
    // {
    //     path: 'downloads',
    //     loadChildren: () => import('../../application/others/downloads/downloads.module').then(m => m.DownloadsModule)
    // },
    // {
    //     path: 'timeline',
    //     loadChildren: () => import('../../application/others/timeline/timeline.module').then(m => m.TimelineModule)
    // },
    // {
    //     path: 'charts',
    //     loadChildren: () => import('../../application/reports/charts/chart.module').then(m => m.ChartModule)
    // },
    
];